// import "babel-polyfill";
// import Vue from "vue";
// import "./plugins/vuetify";
// // import VueAnalytics from "vue-analytics";
// import VueGtag from "vue-gtag";
// import App from "./App.vue";
// import router from "./router/router";
// import store from "./store";
// import C from "@/utils/constants.js";
// import "./plugins/vuetify-mask.js";
// // import vuetify from "./plugins/vuetify";
// import Hotjar from "vue-hotjar";
// import "@/assets/fontawesome/css/all.css";
// // import { VueMaskDirective } from 'v-mask'
//
// import VueMask from "v-mask";
// import {createVuetify} from "vuetify";
// // Vue.use(VueMask);
//
// // Vue.use(Hotjar, {
// //   id: process.env.VUE_APP_HOTJAR_ID,
// //   isProduction: true,
// //   snippetVersion: 6,
// // });
//
//
// // Vue.use(VueAnalytics, {
// //   id: process.env.VUE_APP_GOOGLE_ANALYTICS,
// //   debug: {
// //     enabled: false,
// //   },
// //   router,
// // });
// // Vue.use(
// //   VueGtag,
// //   {
// //     config: {
// //       id: process.env.VUE_APP_GOOGLE_ANALYTICS_4,
// //       params: {
// //         send_page_view: false,
// //       },
// //     },
// //   },
// //   router
// // );
//
// // Vue.config.productionTip = false;
// //
// // Vue.prototype.$eventBus = new Vue();
// // Vue.prototype.$const = C;
//
// // Vue.directive("mask", VueMaskDirective);
//
//
//
// // new Vue({
// //   router,
// //   store,
// //   vuetify,
// //   render: (h) => h(App),
// // }).$mount("#app");
//
// const app = createApp();
// const vuetify = createVuetify({});
// app.use(vuetify);
//

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueHotjar from "vue-hotjar-next";
import "@mdi/font/css/materialdesignicons.css";
import VueGtag from "vue-gtag";

import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

import "@/assets/fontawesome/css/all.css";
import { aliases, fa } from "vuetify/iconsets/fa";

const psLightTheme = {
  dark: false,
  background: "red",
  colors: {
    primary: "#00C8A8",
    secondary: "#818181",
    accent: "#B2DFDB",
    warning: "#ffc107",
    error: "#F03B48",
    btncolor: "#4A90E2",
    btnhover: "#008c75",
    btnwarning: "#AF322F",
    secondarylight: "#BBBBBB",
    anchor: "#00C8A8",
    brokerBoostEnabled: "#006B59",
    brokerBoostDisabled: "#6D6D6D",
    navDrawerBackground: "#363636",
  },
};

const hjConfig = {
  id: Number(process.env.VUE_APP_HOTJAR_ID),
  isProduction: true,
  snippetVersion: 6,
};

const gaConfigId = () => {
  const hostname = window.location.hostname;
  let key;
  switch (hostname) {
    case process.env.VUE_APP_AGENT_HOSTNAME:
      key = process.env.VUE_APP_AGENT_GOOGLE_ANALYTICS_4;
      break;
    case process.env.VUE_APP_BROKER_HOSTNAME:
      key = process.env.VUE_APP_GOOGLE_ANALYTICS_4;
      break;
    default:
      console.log("we got default key here to be brokers GA4 property...");
      key = process.env.VUE_APP_GOOGLE_ANALYTICS_4;
  }
  // console.log("Returning key: " + key);
  return key;
};

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "psLightTheme",
    themes: {
      psLightTheme,
    },
  },
  icons: {
    defaultSet: "fa",
    aliases,
    sets: {
      fa,
    },
  },
});

const app = createApp(App);
app.use(router);
app.use(store);
app.use(vuetify);
app.use(VueHotjar, hjConfig);
app.use(VueGtag, {
  pageTrackerTemplate(to) {
    return {
      page_title: router.currentRoute.name + " | " + store.state.user.userType,
      page_path: to.path,
    };
  },
  config: {
    id: gaConfigId(), //process.env.VUE_APP_GOOGLE_ANALYTICS_4,
    params: {
      send_page_view: false,
    },
  },
});
app.provide("app", app);
app.mount("#app");
